export default "__VITE_ASSET__d7420eec__"